/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * AddressControllerApi - axios parameter creator
 */
export const AddressControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Endpoint for migrating addresses (for internal usage only)
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MigrateAddressesRequestV1} MigrateAddressesRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantAddressesPost: (tenant_1, MigrateAddressesRequestV1_1, ...args_1) => __awaiter(this, [tenant_1, MigrateAddressesRequestV1_1, ...args_1], void 0, function* (tenant, MigrateAddressesRequestV1, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantAddressesPost', 'tenant', tenant);
            // verify required parameter 'MigrateAddressesRequestV1' is not null or undefined
            assertParamExists('addressesV2TenantAddressesPost', 'MigrateAddressesRequestV1', MigrateAddressesRequestV1);
            const localVarPath = `/addresses/v2/{tenant}/addresses`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MigrateAddressesRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to get the ZIP of the default door delivery address of a customer. The endpoint is needed for the NOW Modals
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantDefaultZipGet: (tenant_1, ...args_1) => __awaiter(this, [tenant_1, ...args_1], void 0, function* (tenant, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantDefaultZipGet', 'tenant', tenant);
            const localVarPath = `/addresses/v2/{tenant}/defaultZip`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantDoorDeliveryGet: (tenant_1, ...args_1) => __awaiter(this, [tenant_1, ...args_1], void 0, function* (tenant, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantDoorDeliveryGet', 'tenant', tenant);
            const localVarPath = `/addresses/v2/{tenant}/doorDelivery`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {AddressesV2TenantGetClientPlatformEnum} [clientPlatform] The number of items to skip before starting to collect the result set
         * @param {Array<AddressesV2TenantGetTypesEnum>} [types] used to get specific types of addresses
         * @param {string} [orderDraftId] Id of odrder draft that is needed for fetching Now data.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addressesV2TenantGet: (tenant_1, clientPlatform_1, types_1, orderDraftId_1, ...args_1) => __awaiter(this, [tenant_1, clientPlatform_1, types_1, orderDraftId_1, ...args_1], void 0, function* (tenant, clientPlatform, types, orderDraftId, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantGet', 'tenant', tenant);
            const localVarPath = `/addresses/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (clientPlatform !== undefined) {
                localVarQueryParameter['clientPlatform'] = clientPlatform;
            }
            if (types) {
                localVarQueryParameter['types'] = types;
            }
            if (orderDraftId !== undefined) {
                localVarQueryParameter['orderDraftId'] = orderDraftId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to delete an address given address id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantIdDelete: (tenant_1, id_1, ...args_1) => __awaiter(this, [tenant_1, id_1, ...args_1], void 0, function* (tenant, id, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantIdDelete', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addressesV2TenantIdDelete', 'id', id);
            const localVarPath = `/addresses/v2/{tenant}/{id}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to update an address given address id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {AddressesV2TenantIdPutRequest} AddressesV2TenantIdPutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantIdPut: (tenant_1, id_1, AddressesV2TenantIdPutRequest_1, ...args_1) => __awaiter(this, [tenant_1, id_1, AddressesV2TenantIdPutRequest_1, ...args_1], void 0, function* (tenant, id, AddressesV2TenantIdPutRequest, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantIdPut', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addressesV2TenantIdPut', 'id', id);
            // verify required parameter 'AddressesV2TenantIdPutRequest' is not null or undefined
            assertParamExists('addressesV2TenantIdPut', 'AddressesV2TenantIdPutRequest', AddressesV2TenantIdPutRequest);
            const localVarPath = `/addresses/v2/{tenant}/{id}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(AddressesV2TenantIdPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses that also include \'now service\' data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {AddressesV2TenantOrderDraftIdDoorDeliveryGetClientPlatformEnum} [clientPlatform] The number of items to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addressesV2TenantOrderDraftIdDoorDeliveryGet: (tenant_1, orderDraftId_1, clientPlatform_1, ...args_1) => __awaiter(this, [tenant_1, orderDraftId_1, clientPlatform_1, ...args_1], void 0, function* (tenant, orderDraftId, clientPlatform, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantOrderDraftIdDoorDeliveryGet', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('addressesV2TenantOrderDraftIdDoorDeliveryGet', 'orderDraftId', orderDraftId);
            const localVarPath = `/addresses/v2/{tenant}/{orderDraftId}/doorDelivery`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (clientPlatform !== undefined) {
                localVarQueryParameter['clientPlatform'] = clientPlatform;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to get pickupStation addresses of a customer
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantPickupStationDeliveryGet: (tenant_1, ...args_1) => __awaiter(this, [tenant_1, ...args_1], void 0, function* (tenant, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantPickupStationDeliveryGet', 'tenant', tenant);
            const localVarPath = `/addresses/v2/{tenant}/pickupStationDelivery`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to create an address
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {AddressesV2TenantPostRequest} AddressesV2TenantPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantPost: (tenant_1, AddressesV2TenantPostRequest_1, ...args_1) => __awaiter(this, [tenant_1, AddressesV2TenantPostRequest_1, ...args_1], void 0, function* (tenant, AddressesV2TenantPostRequest, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantPost', 'tenant', tenant);
            // verify required parameter 'AddressesV2TenantPostRequest' is not null or undefined
            assertParamExists('addressesV2TenantPost', 'AddressesV2TenantPostRequest', AddressesV2TenantPostRequest);
            const localVarPath = `/addresses/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(AddressesV2TenantPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AddressControllerApi - functional programming interface
 */
export const AddressControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AddressControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Endpoint for migrating addresses (for internal usage only)
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MigrateAddressesRequestV1} MigrateAddressesRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantAddressesPost(tenant, MigrateAddressesRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantAddressesPost(tenant, MigrateAddressesRequestV1, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AddressControllerApi.addressesV2TenantAddressesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Endpoint to get the ZIP of the default door delivery address of a customer. The endpoint is needed for the NOW Modals
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantDefaultZipGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantDefaultZipGet(tenant, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AddressControllerApi.addressesV2TenantDefaultZipGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantDoorDeliveryGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantDoorDeliveryGet(tenant, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AddressControllerApi.addressesV2TenantDoorDeliveryGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {AddressesV2TenantGetClientPlatformEnum} [clientPlatform] The number of items to skip before starting to collect the result set
         * @param {Array<AddressesV2TenantGetTypesEnum>} [types] used to get specific types of addresses
         * @param {string} [orderDraftId] Id of odrder draft that is needed for fetching Now data.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addressesV2TenantGet(tenant, clientPlatform, types, orderDraftId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantGet(tenant, clientPlatform, types, orderDraftId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AddressControllerApi.addressesV2TenantGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Endpoint to delete an address given address id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantIdDelete(tenant, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantIdDelete(tenant, id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AddressControllerApi.addressesV2TenantIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Endpoint to update an address given address id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {AddressesV2TenantIdPutRequest} AddressesV2TenantIdPutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantIdPut(tenant, id, AddressesV2TenantIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantIdPut(tenant, id, AddressesV2TenantIdPutRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AddressControllerApi.addressesV2TenantIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses that also include \'now service\' data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {AddressesV2TenantOrderDraftIdDoorDeliveryGetClientPlatformEnum} [clientPlatform] The number of items to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addressesV2TenantOrderDraftIdDoorDeliveryGet(tenant, orderDraftId, clientPlatform, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantOrderDraftIdDoorDeliveryGet(tenant, orderDraftId, clientPlatform, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AddressControllerApi.addressesV2TenantOrderDraftIdDoorDeliveryGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Endpoint to get pickupStation addresses of a customer
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantPickupStationDeliveryGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantPickupStationDeliveryGet(tenant, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AddressControllerApi.addressesV2TenantPickupStationDeliveryGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Endpoint to create an address
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {AddressesV2TenantPostRequest} AddressesV2TenantPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantPost(tenant, AddressesV2TenantPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantPost(tenant, AddressesV2TenantPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AddressControllerApi.addressesV2TenantPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AddressControllerApi - factory interface
 */
export const AddressControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AddressControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Endpoint for migrating addresses (for internal usage only)
         * @param {AddressControllerApiAddressesV2TenantAddressesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantAddressesPost(requestParameters, options) {
            return localVarFp.addressesV2TenantAddressesPost(requestParameters.tenant, requestParameters.MigrateAddressesRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to get the ZIP of the default door delivery address of a customer. The endpoint is needed for the NOW Modals
         * @param {AddressControllerApiAddressesV2TenantDefaultZipGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantDefaultZipGet(requestParameters, options) {
            return localVarFp.addressesV2TenantDefaultZipGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses
         * @param {AddressControllerApiAddressesV2TenantDoorDeliveryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantDoorDeliveryGet(requestParameters, options) {
            return localVarFp.addressesV2TenantDoorDeliveryGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
         * @param {AddressControllerApiAddressesV2TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addressesV2TenantGet(requestParameters, options) {
            return localVarFp.addressesV2TenantGet(requestParameters.tenant, requestParameters.clientPlatform, requestParameters.types, requestParameters.orderDraftId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to delete an address given address id
         * @param {AddressControllerApiAddressesV2TenantIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantIdDelete(requestParameters, options) {
            return localVarFp.addressesV2TenantIdDelete(requestParameters.tenant, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to update an address given address id
         * @param {AddressControllerApiAddressesV2TenantIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantIdPut(requestParameters, options) {
            return localVarFp.addressesV2TenantIdPut(requestParameters.tenant, requestParameters.id, requestParameters.AddressesV2TenantIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses that also include \'now service\' data.
         * @param {AddressControllerApiAddressesV2TenantOrderDraftIdDoorDeliveryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addressesV2TenantOrderDraftIdDoorDeliveryGet(requestParameters, options) {
            return localVarFp.addressesV2TenantOrderDraftIdDoorDeliveryGet(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.clientPlatform, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to get pickupStation addresses of a customer
         * @param {AddressControllerApiAddressesV2TenantPickupStationDeliveryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantPickupStationDeliveryGet(requestParameters, options) {
            return localVarFp.addressesV2TenantPickupStationDeliveryGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to create an address
         * @param {AddressControllerApiAddressesV2TenantPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantPost(requestParameters, options) {
            return localVarFp.addressesV2TenantPost(requestParameters.tenant, requestParameters.AddressesV2TenantPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AddressControllerApi - object-oriented interface
 */
export class AddressControllerApi extends BaseAPI {
    /**
     *
     * @summary Endpoint for migrating addresses (for internal usage only)
     * @param {AddressControllerApiAddressesV2TenantAddressesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantAddressesPost(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantAddressesPost(requestParameters.tenant, requestParameters.MigrateAddressesRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to get the ZIP of the default door delivery address of a customer. The endpoint is needed for the NOW Modals
     * @param {AddressControllerApiAddressesV2TenantDefaultZipGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantDefaultZipGet(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantDefaultZipGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses
     * @param {AddressControllerApiAddressesV2TenantDoorDeliveryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantDoorDeliveryGet(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantDoorDeliveryGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
     * @param {AddressControllerApiAddressesV2TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    addressesV2TenantGet(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantGet(requestParameters.tenant, requestParameters.clientPlatform, requestParameters.types, requestParameters.orderDraftId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to delete an address given address id
     * @param {AddressControllerApiAddressesV2TenantIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantIdDelete(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantIdDelete(requestParameters.tenant, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to update an address given address id
     * @param {AddressControllerApiAddressesV2TenantIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantIdPut(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantIdPut(requestParameters.tenant, requestParameters.id, requestParameters.AddressesV2TenantIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses that also include \'now service\' data.
     * @param {AddressControllerApiAddressesV2TenantOrderDraftIdDoorDeliveryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    addressesV2TenantOrderDraftIdDoorDeliveryGet(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantOrderDraftIdDoorDeliveryGet(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.clientPlatform, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to get pickupStation addresses of a customer
     * @param {AddressControllerApiAddressesV2TenantPickupStationDeliveryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantPickupStationDeliveryGet(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantPickupStationDeliveryGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to create an address
     * @param {AddressControllerApiAddressesV2TenantPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantPost(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantPost(requestParameters.tenant, requestParameters.AddressesV2TenantPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const AddressesV2TenantGetClientPlatformEnum = {
    WebDesktop: 'web_desktop',
    WebMobile: 'web_mobile',
    Ios: 'ios',
    Android: 'android'
};
export const AddressesV2TenantGetTypesEnum = {
    Billing: 'billing',
    PickupStation: 'pickupStation',
    Shipping: 'shipping'
};
export const AddressesV2TenantOrderDraftIdDoorDeliveryGetClientPlatformEnum = {
    WebDesktop: 'web_desktop',
    WebMobile: 'web_mobile',
    Ios: 'ios',
    Android: 'android'
};
